<template>
  <div class="rs-campaign" v-if="pageState.status.isLoaded && page">
    <template v-if="page.sections && page.sections.length">
      <section v-for="(section, index) in page.sections" :key="index">
        <section v-if="section.static_section_id == 'banner'">
          <CampaignBanner :banner="section" :sectionType="'banner'"></CampaignBanner>
        </section>
        <section class="promo-banner" v-if="section.template_id.isUseCases">
          <PromoBanner :section="section" />
        </section>
        <section v-if="section.static_section_id == 'features'" class="features-section">
          <div>
            <rz-markdown v-if="section.detail.desc"
            :text="section.detail.desc"></rz-markdown>
            <div v-if="section.detail.items.length > 0" class="features-list">
              <div v-for="(item, itemIndex) in section.detail.items" :key="item.name" class="features">
                <rz-image-item
                  v-if="item.img" :image="item.img" />
                <div class="wrapper">
                  <rz-link-item v-if="item.links[0]"
                  :link="item.links[0]"></rz-link-item>
                  <rz-markdown v-if="item.desc"
                  :text="item.desc"></rz-markdown>
                  <img :src="getFeatureLogo(itemIndex)"
                  :alt="getFeatureLogoAlt(itemIndex)" class="client-logo"/>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section v-if="section.static_section_id == 'faqs'" class="faqs">
          <div>
            <div class="container-wrapper">
              <rz-markdown v-if="section.detail.desc" class="faq-title"
                :text="section.detail.desc"></rz-markdown>
              <div class="faq-wrapper">
                <div v-for="(item, index) in section.detail.items"
                  :key="index" :class="item + '-section'" class="flex-item-wrapper">
                  <div class="flex-item-header clickable" @click="collapseSection(index)">
                    <h4 class="title">
                        {{item.name}}</h4>
                    <span class="expand" :class="[opened.includes(index) ? '': 'hide']"
                    ></span>
                  </div>
                  <div class="rs-flex-box" :class="[opened.includes(index) ? 'show': 'hide']">
                    <div class="inner-box">
                      <rz-markdown v-if="item.desc"
                      :text="item.desc"></rz-markdown>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section v-if="section.static_section_id == 'footer_banner'" class="footer-banner">
          <div class="rs-container">
           <rz-markdown v-if="section.detail.name"
            :text="section.detail.name"></rz-markdown>
            <div v-if="section.detail.links.length > 0" class="links-container">
              <div v-for="(link, idx) in section.detail.links" :key="idx">
                <TextButton :buttonType="'rs-button'" :key="link.name" :link="link" />
              </div>
            </div>
          </div>
        </section>
      </section>
    </template>
  </div>
  <div class="content placeholder" v-else>
    <CricketLoadingPlaceholder :state="pageState"/>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import CricketLoadingPlaceholder from '@/components/SportsHome/CricketLoadingPlaceholder.vue';
import CampaignBanner from '@/components/RsCricket/CampaignBanner.vue';
import PromoBanner from '@/components/RsCricket/PromoBanner.vue';
import TextButton from '@/components/RZWebsite/TextButton.vue';


export default {
  components: {
    CricketLoadingPlaceholder,
    CampaignBanner,
    PromoBanner,
    TextButton,
  },
  computed: {
    ...mapState({
      dataLoaded: (state) => state.page.activePageState.status.isLoaded,
      pageState: (state) => state.page.activePageState,
      page: (state) => state.page.activePage,
    }),
  },
  serverPrefetch() {
    return this.fetchData();
  },
  data() {
    return {
      opened: [],
    };
  },
  mounted() {
    console.log('this.dataLoaded', this.dataLoaded);
    if (this.dataLoaded) {
      const sameRoute = this.page.route_value === 'rs-campaign-test';
      if (!sameRoute) {
        console.log('Refreshing page because page mounted with different route');
        this.refreshPage();
        return;
      }
    }

    if (!this.dataLoaded) {
      this.freshFetch();
    }
  },
  methods: {
    freshFetch() {
      return this.fetchData().then(() => {
        setTimeout(() => {
          this.collapseSection(0);
        }, 1000);
      });
    },
    fetchData() {
      console.log('Fetching page data for campaign');
      const route = '/rs/campaigns/';
      const routeValue = 'rs-campaign-test';
      return this.$store.dispatch('page/fetchActivePage', { route, routeValue });
    },
    refreshPage() {
      this.$store.commit('page/resetActivePage');
      this.freshFetch();
    },
    collapseSection(id) {
      const index = this.opened.indexOf(id);
      const contentContainer = document.getElementsByClassName('rs-flex-box')[id];
      if (contentContainer) {
        if (index > -1) {
          this.opened.splice(index, 1);
          contentContainer.setAttribute('style', '');
        } else {
          this.opened.push(id);
          contentContainer.style.height = `${contentContainer.scrollHeight}px`;
          contentContainer.style.minHeight = `${contentContainer.scrollHeight}px`;
        }
      }
    },
    getFeatureLogo(index) {
      const logos = [
        'https://assets.sports.dev.roanuz.com/uploads-v5/cricket/website/blogs/24oct2025/Live%20scores&commentary.png',
        'https://assets.sports.dev.roanuz.com/uploads-v5/cricket/website/blogs/24oct2025/PerformanceAPI.png',
        'https://assets.sports.dev.roanuz.com/uploads-v5/cricket/website/blogs/24oct2025/FantasyAPI.png',
      ];
      return logos[index % logos.length];
    },
    getFeatureLogoAlt(index) {
      const alts = [
        'Live scores & commentary',
        'Performance API',
        'Fantasy API',
      ];
      return alts[index % alts.length];
    },

  },
};
</script>
<style lang="scss" scoped>
.rs-campaign {
  font-family: var(--rz-hero-font);
  .promo-banner {
    max-width: size(320);
    margin: 0 auto;

    @media screen and (min-width:  $breakpoint-md) {
      max-width: size(700);
    }

    @media screen and (min-width:  $breakpoint-lg) {
      max-width: size(1200);
    }
  }
  .footer-banner {
    background-color: var(--rs-dark-blue-color);
    color: var(--rs-white-color);
    background-image: url('../../assets/campaign/footer_bg1.png'), url("../../assets/campaign/footer_bg2.png");
    background-repeat: no-repeat, no-repeat;
    background-position: left top, right 0 bottom size(10);
    background-size: 8%;
    padding: size(30);
    @media screen and (min-width:  $breakpoint-md) {
      padding: size(60) size(30);
    }
    @media screen and (min-width:  $breakpoint-lg) {
      padding: size(130) size(120);
    }
    .rs-container {
      display: flex;
      justify-content: center;
      flex-direction: column;
      max-width: size(1440);
      margin: 0 auto;
      text-align: center;
      .links-container {
        display: flex;
        justify-content: center;
        gap: size(8);
        flex-direction: column;
        @media screen and (min-width: $breakpoint-md) {
          flex-direction: row;
          gap: size(20);
        }
      };
    }
  }
  .features-section {
    margin-bottom: size(30);
    @media screen and (min-width: $breakpoint-md) {
      margin-bottom: size(60);
    }
    @media screen and (min-width: $breakpoint-lg) {
      margin-bottom: size(120);
    }
    div {
      max-width: size(320);
      margin: 0 auto;

      @media screen and (min-width: $breakpoint-md) {
        max-width: size(700);
      }

      @media screen and (min-width: $breakpoint-lg) {
        max-width: size(1200);
      }
      .features-list {
        display: flex;
        align-items: start;
        justify-content: center;
        gap: size(20);
        flex-direction: column;
        @media screen and (min-width: $breakpoint-md) {
          flex-direction: row;
          flex-wrap: wrap;
          gap: size(30);
        }
        .features {
          max-width: 100%;
          border-radius: size(6);
          box-shadow: 0 0 30px 0 rgba(141, 151, 158, 0.20);
          background: var(--rs-white-color);
          @media screen and (min-width: $breakpoint-md) {
            max-width: calc((100% / 2) - 15px);
          }
          @media screen and (min-width: $breakpoint-lg) {
            max-width: calc((100% / 3) - 30px);
            min-height: size(560);
          }
          .wrapper {
            padding: size(30);
            .client-logo {
              max-width: 100%;
            }
          }
        }
      }
    }
  }
  .faqs {
    background:#111;
    .container-wrapper {
      margin: 0 auto;
      max-width: size(320);
      margin: 0 auto;
      padding: size(30);

      @media screen and (min-width: $breakpoint-md) {
        display: flex;
        align-items: start;
        justify-content: space-between;
        gap: size(30);
        padding: size(60) size(30);
        max-width: size(700);
      }

      @media screen and (min-width: $breakpoint-lg) {
        max-width: size(1200);
        padding: size(90) size(120);
      }
    }
  }
}

</style>

<style lang="scss">
.rs-campaign {
  .promo-banner {
    .promo {
      .rs-container {
        padding-top: 0;
        margin-bottom: size(30);
        @media screen and (min-width:  $breakpoint-md) {
          margin-bottom: size(60);
        }
        @media screen and (min-width:  $breakpoint-lg) {
          margin-bottom: size(120);
        }
      }
    }
  }
  .footer-banner {
    .markdown {
      .p {
        font-size: size(24);
        font-weight: 700;
        margin-bottom: size(30);
        line-height: 1.4;
        margin: 0 auto;
        max-width: size(320);
        margin-bottom: size(30);
        @media screen and (min-width: $breakpoint-md) {
          max-width: size(700);
        }

        @media screen and (min-width: $breakpoint-lg) {
          font-size: size(50);
          font-weight: 700;
          margin-bottom: size(48);
          max-width: size(1200);
        }
      }
    }
    .links-container {
      .markdown {
        .p {
          color: var(--rs-white-color);
          a {
            margin-top: 0;
            color: var(--rs-white-color);
          }
        }
      }
      .text-button {
        .link {
          color: var(--rs-white-color);
          border: var(--rs-white-color) 1px solid;
          margin-top: 0;
          &:after {
            border-color: var(--rs-white-color);
          }
        }
      }
      div {
        &:first-child {
          .text-button {
            .link {
              background:#F5FF78;
              border-color: #F5FF78;
              color: var(--rs-black-color);
              &:after {
                border-color: var(--rs-black-color);
              }
            }
          }
        }
      }
    }
  }
  .features-section {
    .markdown {
      h2 {
        font-size: size(30);
        font-weight: 800;
        line-height: size(44);
        color: #111;
        padding-bottom: size(30);

        @media screen and (min-width: $breakpoint-md) {
          font-size: size(42);
          line-height: size(56);

        }

        @media screen and (min-width: $breakpoint-lg) {
          font-size: size(80);
          line-height: size(90);
          max-width: size(890);
          padding-bottom: size(90);
        }

        strong {
          color: var(--rs-pink-color);
        }
      }
      .p {
        font-size: size(14);
        font-weight: 400;
        line-height: size(20);
        padding-bottom: size(24);
      }
    }
    .link-item {
      padding-bottom: size(10);
      &:hover {
        .link-plain {
          &:after {
            @include move-animation;
          }
        }
      }
      .link-plain {
        font-size: size(16);
        font-weight: 700;
        color: var(--rz-link-color);

        @media screen and (min-width: $breakpoint-md) {
          font-size: size(18);
        }


        &:after {
          content: '';
          border: solid var(--rz-link-color);
          border-width: 0 size(2) size(2) 0;
          display: inline-block;
          padding: size(2.2);
          transform: rotate(-45deg);
          -webkit-transform: rotate(-45deg);
          margin-left: size(5);
          vertical-align: middle;
        }
      }
    }

    .features {
      .image-item {
        height: size(230);
        @media screen and (min-width: $breakpoint-md) {
          height: size(235);
        }
        @media screen and (min-width: $breakpoint-lg) {
          height: 100%;
        }
      }
    }
  }
  .faqs {
    .rs-flex-box {
      transition: height .6s cubic-bezier(.645,.045,.355,1), opacity .3s cubic-bezier(.645,.045,.355,1),
      min-height .6s cubic-bezier(.645,.045,.355,1);
      opacity: 1;
      height: 0;
      min-height: 0;
      overflow: hidden;
      &.hide {
        opacity: 0;
      }
    }
    .expand {
      &.hide {
        transform:rotate(-180deg);
      }
    }
    .expand {
      cursor: pointer;
      width: size(16);
      height: size(16);
      background-color: transparent;
      border: 0;
      display: inline-block;
      background: url('../../assets/campaign/Arrow.svg') no-repeat center;
      transition: transform 300ms cubic-bezier(.694,0,.335,1);
    }
    .flex-item-wrapper {
      padding: size(20) 0;
      border-bottom: 1px solid#C4C4C4;
      @media screen and (min-width: $breakpoint-md) {
        padding: size(30) 0;
      }
      &:first-child {
        padding-top: 0;
      }
      &:last-child {
        border-bottom: none;
      }

      .flex-item-header {
        font-size: size(16);
        font-weight: 700;
        color: #F5FF78;
        display: flex;
        justify-content: space-between;
        align-self: start;
        cursor: pointer;

        @media screen and (min-width: $breakpoint-md) {
          font-size: size(18);
        }
      }

      .inner-box {
        .p {
          padding-top: size(12);
          font-size: size(16);
          font-weight: 400;
          line-height: size(28);
          color: var(--rs-white-color);
        }
      }
    }

    .markdown {
      &.faq-title {
        h3 {
          font-size: size(24);
          font-weight: 700;
          line-height: size(32);
          color: var(--rs-white-color);
          padding-bottom: size(30);

          @media screen and (min-width: $breakpoint-md) {
            font-size: size(30);
            line-height: size(44);
          }
          @media screen and (min-width: $breakpoint-lg) {
            font-size: size(60);
            line-height: size(72);
          }
        }
      }
    }
  }
}
</style>
